import React, {useEffect, useState} from 'react'
import {EmployeeLayout} from '../EmployeeLayout/EmployeeLayout'
import {Jobs} from '../../../UnAuthenticated/Jobs/Jobs'
import {Job} from "../Types/Job";
import {serverConn} from "../../../API/apiRequest";
import classes from "./EmployeeHome.module.css";
import {Button} from '../../../components/Button/Button';
import {useMediaQuery} from '@material-ui/core'
import {Loading} from "../../../components/Loading/Loading";
import {useLocation} from "react-router";
import {NoData} from '../../../components/NoData/NoData';
import ReactGA from "react-ga"

interface Props {
}

export const EmployeeHome: React.FC<Props> = () => {
    const [data, setdata] = useState<{ hasNext: boolean, jobs: Array<Job>, lastPage: number, nextPage: number, totalJobs: number }>();
    const [Jobsdata, setJobsdata] = useState<Array<Job>>([])
    const [page, setpage] = useState<number>(1);
    const [searchtext, setsearchtext] = useState<string>();
    const matches = useMediaQuery('(max-width:510px)');
    const [Load, setLoad] = useState<boolean>(true)
    const [search, setsearch] = useState<boolean>(false)
    const [LoadJob, setLoadJob] = useState<boolean>(false)
    const [exp, setexp] = useState<{ label: string, value: string }>();
    const [edu, setedu] = useState<{ label: string, value: string }>();
    const [field, setfield] = useState<{ label: string, value: string }>();
    const [noData, setnoData] = useState<boolean>(false);
    const {pathname} = useLocation();
    useEffect(() => {
        setLoad(true)
        serverConn.get(`/jobs${exp ? `/search?exp=${exp}&page=${page}` : `?page=${page}`}`).then((res) => {
            if(res.status === 200) {
                setdata(res.data)
                setJobsdata(res.data.jobs)
                setLoad(false)
            }
        })
        ReactGA.pageview(window.location.pathname)
        // eslint-disable-next-line
    }, [page, pathname])

    function handlesearch() {
        setLoadJob(true)
        serverConn.get(`/jobs/search?q=${searchtext && searchtext.length > 0 ? searchtext : ""}&exp=${exp && exp.value ? exp.value : ""}&edu=${edu && edu.value ? edu.value : ""}&field=${field && field.value ? field.value : ""}&page=${page}`).then((res) => {
            if(res.status === 200 && res.data.jobs.length > 0) {
                setdata(res.data)
                setsearch(true)
                setJobsdata(res.data.jobs)
                setLoadJob(false)
            } else if(res.data.jobs.length === 0) {
                setnoData(true)
            }
        })
    }

    useEffect(() => {
                if((field === null || edu === null || exp === null) && search) {
                    handlesearch()
                }
            },
            // eslint-disable-next-line
            [field, edu, exp])

    function handleClearSearch() {
        setfield(undefined)
        setedu(undefined)
        setexp(undefined)
        setsearchtext("");
        if(search) {
            setLoadJob(true)
            serverConn.get(`/jobs${exp ? `/search?exp=${exp}&page=${page}` : `?page=${page}`}`).then((res) => {
                if(res.status === 200) {
                    setdata(res.data)
                    setJobsdata(res.data.jobs)
                    setLoadJob(false)
                }
            })
            setsearch(false)
        }
    }

    return (
            <>
                <EmployeeLayout>

                    {Load && !noData ? (<Loading/>) : noData ? (<NoData/>) : (
                            <div className={'mxheight100  pb25px animate__animated animate__fadeIn'}>

                                <Jobs without data={Jobsdata}
                                      searchstate={!!(exp || edu || field || searchtext)}
                                      setUserexp={setexp}
                                      exp={exp}
                                      edu={edu}
                                      field={field}
                                      setUseredu={setedu}
                                      handleClearSearch={handleClearSearch}
                                      setUserfield={setfield}
                                      LoadJob={LoadJob} searchtext={searchtext} handlesearch={handlesearch}
                                      handlesetsearchtext={(e: string) => {
                                          setsearchtext(e)
                                      }} nostyle/>


                                <div className={'d-flex w-100 justify-content-center'}>
                                    <div className={"my-2 " + classes.pages}>
                                        <Button width={matches ? 150 : undefined} height={matches ? 38 : undefined}
                                                disabled={!(data && data.hasNext)}
                                                onPress={() => {
                                                    if(data && data.hasNext) {
                                                        let num = page;
                                                        num++;
                                                        setpage(num);
                                                    }
                                                }}
                                                color='black'>التالي</Button>

                                        <Button width={matches ? 150 : undefined} height={matches ? 38 : undefined}


                                                loading={false}
                                                disabled={page <= 1}
                                                onPress={() => {
                                                    if(page > 1) {
                                                        let num = page;
                                                        num--;
                                                        setpage(num);
                                                    }
                                                }}
                                                color='black'>السابق</Button>

                                    </div>
                                </div>
                            </div>
                    )}


                </EmployeeLayout>
            </>)
}